import React, { useEffect, useState } from "react";
import Navigation from "../../components/Navigation";
import { Button } from "react-bootstrap";
import { ReactFlagsSelect } from "react-flags-select";
import Constants from "../Variables/Constants";
import { toast } from "react-toastify";
import axios from "axios";
import { useDispatch } from "react-redux";
import { setCartItems } from "../../redux/cartSlice";
import { useNavigate } from "react-router-dom";
import { getUniqueId } from "../../utils";
import NoData from "./../../components/NoData";

const SavedDesign = () => {
  const [images, setImages] = useState([]);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const fetchImages = async () => {
    try {
      const response = await axios.get(
        Constants.getUrls.getAllCustomizedImage,
        {
          headers: {
            Authorization: localStorage.getItem("token"),
          },
        }
      );
      if (response.data.status === "success") {
        const data = response.data.data;
        if (data && Array.isArray(data)) {
          setImages(data);
        } else {
          toast.clearWaitingQueue();
          toast.dismiss();
          toast.error("Invalid data format received from the server.");
          setImages([]);
        }
      } else {
        toast.clearWaitingQueue();
        toast.dismiss();
        toast.error(response.data.message);
      }
    } catch (error) {
      try {
        toast.clearWaitingQueue();
        toast.dismiss();
        toast.error(error.message);
        const { status, message } = error.response.data;
        if (status === 401 && message === "Unauthorized!") {
          localStorage.removeItem("token");
          window.location.href = "/";
        }
      } catch (error) {
        toast.clearWaitingQueue();
        toast.dismiss();
        toast.error(error.message);
      }
    }
  };

  const handleRemove = async (product) => {
    try {
      const response = await axios.delete(
        `${Constants.deleteUrls.removeCustomizedImage}/${product._id}`,
        {
          headers: {
            Authorization: localStorage.getItem("token"),
          },
        }
      );
      if (response.data.status === "success") {
        toast.clearWaitingQueue();
        toast.dismiss();
        toast.success("Image removed successfully!", {
          style: { backgroundColor: "green", color: "white" },
        });
        fetchImages();
      } else {
        toast.clearWaitingQueue();
        toast.dismiss();
        toast.error(response.data.message);
      }
    } catch (error) {
      console.error("Error deleting image:", error);
    }
  };

  const fetchCart = async () => {
    try {
      const res = await axios.get(Constants.getUrls.getCart, {
        headers: { Authorization: localStorage.getItem("token") },
      });
      if (res.data.status === "success") {
        const data = res.data.data.docs;
        const arr = [];
        if (data && Array.isArray(data) && data.length > 0) {
          data.map((item) => {
            arr.push({
              _id: item._id,
              product_id: item.product_id._id,
              images: item.product_id.images,
              name: item.product_id.name,
              price: item.product_id.price,
              quantity: item.quantity,
            });
          });
          dispatch(setCartItems(arr));
          localStorage.removeItem("cart");
        } else {
          dispatch(setCartItems([]));
          localStorage.removeItem("cart");
        }
      } else {
        dispatch(setCartItems([]));
        localStorage.removeItem("cart");
      }
    } catch (error) {
      try {
        toast.clearWaitingQueue();
        toast.dismiss();
        toast.error(error.message);
        const { status, message } = error.response.data;
        if (status === 401 && message === "Unauthorized!") {
          localStorage.removeItem("token");
          window.location.href = "/";
        }
      } catch (error) {
        toast.clearWaitingQueue();
        toast.dismiss();
        toast.error(error.message);
      }
    }
  };

  const handleAddToCart = async (image) => {
    try {
      const resp = await axios.get(
        Constants.getUrls.getProduct + "/" + image.product_id
      );
      if (resp.data.status === "success") {
        if (resp.data.data) {
          const product = resp.data.data;
          const formData = new FormData();
          formData.append("main_fabric_id", image.main_fabric_id);
          formData.append("size_id", image.size_id);
          formData.append(
            "name",
            `custom-${product.category.title}-${getUniqueId()}`
          );
          formData.append("category", product.category?._id);
          formData.append("sub_category", product.sub_category?._id);
          formData.append("description", product.description);
          formData.append("image_url", image.customized_image);
          formData.append("quantity", 1);
          formData.append("price", image.price);
          formData.append("offer_price", image.price);
          formData.append("status", "active");
          if (image._id) {
            formData.append("customize_image_id", image._id);
          }
          if (image.matching_bag) {
            formData.append("matching_bag", image.matching_bag);
          }
          if (image.price_data) {
            formData.append("price_data", image.price_data);
          }

          const response = await axios.post(
            Constants.postUrls.addProducts,
            formData,
            {
              headers: {
                Authorization: localStorage.getItem("token"),
              },
            }
          );

          if (response.data.status === "success") {
            const newProd = response.data.data;

            axios
              .post(
                Constants.postUrls.AddToCart,
                {
                  product_id: newProd._id,
                  quantity: 1,
                  customized_image_id: image._id || null,
                },
                {
                  headers: {
                    Authorization: localStorage.getItem("token"),
                  },
                }
              )
              .then((resp) => {
                if (resp.data.status === "success") {
                  toast.clearWaitingQueue();
                  toast.dismiss();
                  toast.success("Product added to cart successfully!", {
                    style: { backgroundColor: "green", color: "white" },
                  });
                  fetchCart();
                }
              })
              .catch((error) => {
                console.error("Error while adding product to cart:", error);
              });
          } else {
            toast.error(response.data.message);
          }
        } else {
          toast.error("Product not found");
        }
      } else {
        toast.error("Product not found");
      }
    } catch (error) {
      try {
        toast.clearWaitingQueue();
        toast.dismiss();
        toast.error(error.message);
        const { status, message } = error.response.data;
        if (status === 401 && message === "Unauthorized!") {
          localStorage.removeItem("token");
          window.location.href = "/";
        }
      } catch (error) {
        toast.clearWaitingQueue();
        toast.dismiss();
        toast.error(error.message);
      }
    }
  };

  useEffect(() => {
    fetchImages();
  }, []);

  return (
    <>
      <Navigation />
      <div className="container">
        <div className="row">
          {images.length > 0 &&
            images.map((image, index) => (
              <div className="col-md-4 col-12 col-sm-6 col-lg-3" key={index}>
                <div className="product_card position-relative">
                  <div className="">
                    <img loading="lazy" 
                      src={Constants.imgDomain + image.customized_image}
                      alt=""
                      style={{
                        cursor: "pointer",
                        height: "300px",
                        height: "300px",
                      }}
                      onClick={() => {
                        navigate(
                          `/customize?productId=${image?.product_id}&isEdit=true&customizeImageId=${image?._id}`
                        );
                      }}
                    />

                    <Button
                      type="button"
                      onClick={() => handleAddToCart(image)}
                      className=""
                    >
                      Add to cart
                    </Button>
                  </div>
                  <img loading="lazy" 
                    className="position-absolute closey object-fit-contain cursor top-5 right-5 c"
                    src="/cut.png"
                    alt=""
                    onClick={() => handleRemove(image)}
                  />
                </div>
              </div>
            ))}

          {images.length === 0 && (
            <>
              <NoData
                image={
                  "https://static.vecteezy.com/system/resources/previews/009/467/878/non_2x/no-product-saved-concept-illustration-flat-design-eps10-modern-graphic-element-for-landing-page-empty-state-ui-infographic-icon-vector.jpg"
                }
                text={`You don't have any saved design`}
              />
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default SavedDesign;
